module.exports = require('./getRoutesFromApps')
